import styled from 'styled-components'

import { FlexDivColCentered } from 'components/layout/flex'

export const TradePanelContainer = styled(FlexDivColCentered)<{ $mobile?: boolean }>`
	scrollbar-width: none;
	border-right: ${(props) => props.theme.colors.selectedTheme.border};
	position: relative;
`
